// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoCard_container__3oAjv","title":"VideoCard_title__2M4AN","admin":"VideoCard_admin__gbHVw"};